import { getResolvedRefDeep as e } from "@scalar/workspace-store/helpers/get-resolved-ref-deep";
import { getResolvedRef as t, mergeSiblingReferences as n } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { buildRequestBody as r, coerceLeafValueToSchemaType as i, getExample as a, getExampleFromSchema as o, needsMultipartEncoding as s, resolveLeafSchema as c, serializeFormPropertyWithEncoding as l, serializeMultipartArray as u, serializeMultipartBody as d } from "@scalar/workspace-store/request-example";
import { json2xml as f } from "@scalar/helpers/file/json2xml";
import { getExampleValue as p, getExplicitExampleText as m } from "@scalar/workspace-store/helpers/get-example-value";
import { serializeStreamExample as h } from "@scalar/workspace-store/helpers/serialize-stream-example";
import { unpackProxyObject as g } from "@scalar/workspace-store/helpers/unpack-proxy";
//#region src/code-example/helpers/operation-to-har/process-body.ts
var _ = (e, t, n, r = !1, a) => {
	let o = [], s = Array.isArray(e) ? e.filter((e) => !e.isDisabled).map((e) => [String(e.name), e.value]) : Object.entries(e);
	for (let [d, f] of s) {
		if (f == null) continue;
		let s = n ? void 0 : t?.[d];
		if (r && !n) {
			let t = Array.isArray(e) ? i(f, c(a, [d])) : f, n = u(d, Array.isArray(t) ? t : f, s);
			if (n) {
				for (let e of n) o.push({
					name: e.key,
					value: e.value instanceof File ? `@${e.value.name}` : e.value,
					...e.contentType ? { contentType: e.contentType } : {}
				});
				continue;
			}
		}
		let p = s && (s.style !== void 0 || s.explode !== void 0 || s.allowReserved !== void 0), m = p || !r ? void 0 : s?.contentType, h = n ? null : l(d, f, s);
		if (h) for (let e of h) o.push({
			name: e.key,
			value: e.value
		});
		else if (f instanceof File) {
			let e = g(f);
			o.push({
				name: d,
				value: `@${e.name}`,
				...m ? { contentType: m } : {}
			});
		} else if (m && typeof f == "object") o.push({
			name: d,
			value: JSON.stringify(g(f)),
			contentType: m
		});
		else if (r && !n && !p && typeof f == "object" && !Array.isArray(f)) o.push({
			name: d,
			value: JSON.stringify(g(f)),
			contentType: "application/json"
		});
		else if (Array.isArray(f)) for (let e of f) if (e instanceof File) {
			let t = g(e);
			o.push({
				name: d,
				value: `@${t.name}`
			});
		} else o.push({
			name: d,
			value: String(e)
		});
		else if (typeof f == "object") {
			let e = _(f, void 0, d);
			for (let t of e) o.push({
				name: `${d}.${t.name}`,
				value: t.value
			});
		} else o.push({
			name: d,
			value: String(f),
			...m ? { contentType: m } : {}
		});
	}
	return o;
}, v = ({ requestBody: i, contentType: c, example: l, requestBodyCompositionSelection: u }) => {
	let v = c || Object.keys(i.content)[0] || "", y = v === "other" ? "" : v, b = (e) => `@${g(e).name || "filename"}`, x = i.content[v]?.encoding, S = i.content[v];
	if (S && s(v, S)) {
		let e = l ?? Object.keys(S.examples ?? {})[0] ?? "default", t = r({
			...i,
			"x-scalar-selected-content-type": { [e]: v }
		}, e, u);
		if (t?.mode === "multipart") {
			let e = d(t.value, t.contentType);
			return {
				mimeType: e.contentType,
				text: e.chunks.map((e) => e instanceof File ? b(e) : e instanceof Blob ? "BINARY" : String(e)).join("")
			};
		}
	}
	let C = v === "multipart/form-data" || v === "application/x-www-form-urlencoded", w = v === "application/xml", T = p(a(i, l, c)), E = m(T, v);
	if (E !== void 0) return {
		mimeType: y,
		text: E
	};
	let D = T?.value;
	if (D !== void 0) {
		let e = typeof D == "object" && D ? g(D) : D;
		return C && typeof e == "object" && e ? {
			mimeType: y,
			params: _(e, x, void 0, v === "multipart/form-data", t(i.content[v]?.schema, n))
		} : w && typeof e == "object" && e ? {
			mimeType: y,
			text: f(e)
		} : e instanceof File ? {
			mimeType: y,
			text: b(e)
		} : {
			mimeType: y,
			text: typeof e == "string" ? e : h(e, v, !1) ?? JSON.stringify(e)
		};
	}
	let O = i.content[v], k = t(O?.schema ?? O?.itemSchema);
	if (k !== void 0) {
		let t = o(e(k), {
			compositionSelection: u,
			mode: "write",
			xml: w
		}, { schemaPath: ["requestBody"] });
		if (t !== void 0) return C && typeof t == "object" && t ? {
			mimeType: y,
			params: _(t, x, void 0, v === "multipart/form-data")
		} : w && typeof t == "object" && t ? {
			mimeType: y,
			text: f(t)
		} : {
			mimeType: y,
			text: h(t, v, O?.schema === void 0) ?? (typeof t == "string" ? t : JSON.stringify(t))
		};
	}
};
//#endregion
export { v as processBody };

//# sourceMappingURL=process-body.js.map